<template>
  <v-app>
    <v-container fluid>

      <v-row>

        <v-col cols="12">

          <v-expansion-panels
            v-model="panel"
            multiple
          >

            <!-- FILTER PANEL -->
            <v-expansion-panel>

              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Search Filters
              </v-expansion-panel-title>

              <v-expansion-panel-text>

                <v-card class="pa-4">

                  <v-row>

                    <!-- FROM DATE -->
                    <v-col md="3" cols="12">
                      <v-date-input
                        label="From Date"
                        v-model="from_date"
                        density="compact"
                        variant="outlined"
                        prepend-icon=""
                        clearable
                        hide-details
                      />
                    </v-col>

                    <!-- TO DATE -->
                    <v-col md="3" cols="12">
                      <v-date-input
                        label="To Date"
                        v-model="to_date"
                        density="compact"
                        variant="outlined"
                        prepend-icon=""
                        clearable
                        hide-details
                      />
                    </v-col>

                    <!-- PRODUCT -->
                    <!-- <v-col md="4" cols="12">
                      <v-autocomplete
                        label="Product"
                        v-model="product_id"
                        :items="getProductList"
                        :item-title="(item) => `${item.product?.code} - ${item.product?.name}`"
                        item-value="id"
                        density="compact"
                        variant="outlined"
                        clearable
                        hide-details
                      />
                    </v-col> -->

                    <!-- SEARCH BUTTON -->
                    <v-col
                      md="2"
                      cols="12"
                      class="d-flex align-center"
                    >
                      <v-btn
                        color="primary"
                        block
                        @click="loadPriceCalculationList"
                      >
                        Search
                      </v-btn>
                    </v-col>

                  </v-row>

                </v-card>

              </v-expansion-panel-text>

            </v-expansion-panel>

            <!-- LIST PANEL -->
            <v-expansion-panel>

              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Price Calculation Records
              </v-expansion-panel-title>

              <v-expansion-panel-text>

                <v-card class="pa-4">

                  <v-data-table
                    :headers="headers"
                    :items="getPriceCalculationList"
                    class="elevation-1"
                  >

                    <!-- SL -->
                    <template #item.index="{ index }">
                      {{ ++index }}
                    </template>

                    <!-- INQUIRY -->
                    <template #item.inquiry="{ item }">
                      {{
                        item?.inquiry_master?.code || "N/A"
                      }}
                    </template>

                    <!-- PRODUCT -->
                    <template #item.product="{ item }">
                      {{
                        item?.inquiry_detail?.product?.name || "N/A"
                      }}
                    </template>

                    <!-- HS CODE -->
                    <template #item.hs_code="{ item }">
                      {{ item?.hs_code || "N/A" }}
                    </template>

                    <!-- ASSESSMENT VALUE -->
                    <template #item.assessment_value="{ item }">
                      {{ item?.assessment_value || 0 }}
                    </template>

                    <!-- PROPOSED PRICE -->
                    <template #item.proposed_price="{ item }">
                      {{ item?.proposed_price || 0 }}
                    </template>

                    <!-- ACTION -->
                    <template #item.actions="{ item }">

                      <v-icon
                        small
                        color="primary"
                        class="me-2 edit-button"
                        title="Edit"
                        @click="editItem(item)"
                      >
                        mdi-pencil-outline
                      </v-icon>

                      <v-icon
                        color="primary"
                        class="me-2"
                        @click="viewItem(item)"
                      >
                        mdi-file-document-outline
                      </v-icon>

                    </template>

                  </v-data-table>

                </v-card>

              </v-expansion-panel-text>

            </v-expansion-panel>

          </v-expansion-panels>

        </v-col>

      </v-row>

    </v-container>
  </v-app>
</template>

<script setup>
import {ref,computed,onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import formattedDate from "@/plugins/dateFormatter";

const store = useStore();
const router = useRouter();

/* ================= PANEL ================= */

const panel = ref([0, 1]);

/* ================= FILTER ================= */

const from_date = ref(null);
const to_date = ref(null);

const product_id = ref(null);

/* ================= HEADERS ================= */

const headers = [

  {
    title: "#SL",
    key: "index",
    align: "center"
  },

  {
    title: "Inquiry",
    key: "inquiry"
  },

  {
    title: "Product",
    key: "product"
  },

  {
    title: "HS Code",
    key: "hs_code"
  },

  {
    title: "Assessment Value",
    key: "assessment_value"
  },

  {
    title: "Proposed Price",
    key: "proposed_price"
  },

  {
    title: "Actions",
    key: "actions"
  },

];

/* ================= GETTERS ================= */

const getPriceCalculationList = computed(() => {

  return store.getters.getPriceCalculationList || [];

});

const getProductList = computed(() => {

  return store.getters.getProductMapList || [];

});

/* ================= METHODS ================= */

const loadPriceCalculationList = async () => {

  try {

    store.commit(
      "SET_LOADING",
      true
    );

    await store.dispatch(
      "getPriceCalculations",
      {
        from_date: formattedDate(from_date.value),
        to_date: formattedDate(to_date.value),
        product_id: product_id.value,
      }
    );

  } catch (error) {

    console.error(error);

  } finally {

    store.commit(
      "UNSET_LOADING"
    );

  }

};

const editItem = (item) => {
  router.push({name: "price-calculation", params: {id: item.id}});
};

const viewItem = (item) => {
  router.push({name: "price-calculation-details", params: {id: item.id}});
};

/* ================= MOUNTED ================= */

onMounted(async () => {

  await store.dispatch("getProductMapList");

  await loadPriceCalculationList();

});
</script>